import React from 'react'
import { H1, H2, H4, P } from '@drifthq/tide-core'

import boltTrioPink from './../bolt-trio-pink.svg'
import installVideoThumbnailSrc from './../assets/install-video-thumbnail.jpg'

import cardSrcCampaign from './../assets/card-img-campaign.jpg'
import cardSrcPersonalized from './../assets/card-img-personalized-videos.jpg'
import cardSrcProductDemo from './../assets/card-img-product-demo.jpg'
import cardSrcSocial from './../assets/card-img-social-shares.jpg'
import cardSrcTestimonial from './../assets/card-img-testimonial.jpg'
import cardSrcTrustworthiness from './../assets/card-img-trustworthiness.jpg'

import { InstallButton } from './../index'

const EducationalCard = ({ thumbnailSrc, titleCopy, bodyCopy }) => (
  <div className="drift-getting-started-educational-card">
    <img src={thumbnailSrc} alt="video-thumbnail" />
    <H4>{titleCopy}</H4>
    <P>{bodyCopy}</P>
  </div>
)

const MarketingInstallVariant = ({ onInstallClick }) => (
  <div>
    <div className="drift-install-education-container">
      <a
        href="https://video.drift.com/share/ab66nw5tj0o/"
        target="_blank"
        rel="noopener noreferrer"
        className="drift-install-video"
      >
        <img src={installVideoThumbnailSrc} alt="welcome video thumbnail" />
      </a>
      <div className="drift-install-section-header">
        <H1 className="drift-getting-started-title">
          If a picture tells a thousand words, then videos let you tell quite a story.&nbsp;
          <span>
            Install the Chrome Extension to get started with Drift Video - it&rsquo;ll take 30 seconds.
          </span>
        </H1>
      </div>
      <InstallButton onInstallClick={onInstallClick} copy="Add Chrome extension" showArrow={true} />
    </div>
    <div className="drift-install-education-container marketing-education blue-graffiti-bg">
      <div className="drift-install-section-header">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <H2 className="drift-getting-started-title">
          Here&rsquo;s how we use Video at Drift, and how you can too!
        </H2>
      </div>
      <div className="drift-install-item-row">
        <div className="education-card-column">
          <EducationalCard
            thumbnailSrc={cardSrcCampaign}
            titleCopy="Add video to email marketing campaigns to improve conversion"
            bodyCopy="Including a video is a great way to make your email campaigns stand out. So effective, in fact, that it leads to a 2-3X increase in click-through rates."
          />
          <EducationalCard
            thumbnailSrc={cardSrcPersonalized}
            titleCopy="Record personalized videos for leads"
            bodyCopy="Creating video content that is customized and relevant to your target audience is an increasingly popular way to make a human connection. Even if your viewers live in a different hemisphere, you can make a connection that feels personal by addressing issues and challenges that are specific to them."
          />
        </div>
        <div className="education-card-column">
          <EducationalCard
            thumbnailSrc={cardSrcSocial}
            titleCopy="Include videos to boost social shares"
            bodyCopy="Posting great video content leads to more social shares, which is a big deal. As a matter of fact, videos are shared 12 times more than links and text posts combined. "
          />
          <EducationalCard
            thumbnailSrc={cardSrcTestimonial}
            titleCopy="Share customer testimonials"
            bodyCopy="Customer testimonials build trust and credibility by letting your company’s loyal customers showcase your products or services. They offer your visitors a human story they can relate to and a real person they can connect with."
          />
        </div>
        <div className="education-card-column">
          <EducationalCard
            thumbnailSrc={cardSrcProductDemo}
            titleCopy="Create product demo videos"
            bodyCopy="Demo videos let you show off a new product or service. Your sales team can use demo videos to explain the value of your offering, highlight how it solves a problem and persuade prospects they can’t live without it."
          />
          <EducationalCard
            thumbnailSrc={cardSrcTrustworthiness}
            titleCopy="Create a sense of trustworthiness and legitimacy"
            bodyCopy="Watching a video is not the same as having a face-to-face chat, but it’s the next closest thing to it. By giving visitors the chance to put a face to your brand, videos are the best way to humanize your company. They allow you to quickly establish a rapport with prospects, which is instrumental in building trust and credibility."
          />
        </div>
      </div>
      <div className="drift-install-marketing-education-footer">
        <span>{'👉'} Want more ways to use Drift Video? We got you.&nbsp;</span>
        <a
          href="https://www.drift.com/blog/3-ways-to-use-drift-video-for-sales-prospecting/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check out our post for more tips.
        </a>
      </div>
    </div>
    <div className="drift-install-education-container install-footer">
      <div className="drift-install-section-header">
        <H2 className="drift-getting-started-title">
          Ready to create videos that start conversations? Simply install the Chrome Extension to get started.
        </H2>
      </div>
      <InstallButton onInstallClick={onInstallClick} copy="Add Drift Video to Chrome" showArrow={true} />
      <P className="button-subcopy">You already have a free account!</P>
    </div>
  </div>
)

export default MarketingInstallVariant



// WEBPACK FOOTER //
// ./src/layouts/VideoInstallStep/variants/marketing-install-component.js